import { NavLink, Outlet, useNavigate } from "react-router-dom";
import clsx from "clsx";

import { clearToken } from "@/lib/auth";

interface NavItem {
  to: string;
  label: string;
  end?: boolean;
}

interface NavSection {
  title: string;
  items: NavItem[];
}

const sections: NavSection[] = [
  {
    title: "CeroDeuda",
    items: [
      { to: "/", label: "Dashboard", end: true },
      { to: "/leads", label: "Leads" },
      { to: "/backfill", label: "Backfill" },
      { to: "/sync-runs", label: "Sync runs" },
    ],
  },
  {
    title: "LeadHoop",
    items: [
      { to: "/leadhoop", label: "Dashboard", end: true },
      { to: "/leadhoop/leads", label: "Leads" },
      { to: "/leadhoop/sync-runs", label: "Sync runs" },
    ],
  },
];

export function Layout() {
  const navigate = useNavigate();

  function logout() {
    clearToken();
    navigate("/login", { replace: true });
  }

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <aside className="flex w-60 flex-col border-r border-slate-200 bg-white">
        <div className="flex items-center gap-2 px-5 py-5">
          <div className="flex h-8 w-8 items-center justify-center rounded-md bg-brand-600 text-white">
            <svg viewBox="0 0 32 32" className="h-5 w-5" fill="none">
              <path
                d="M8 10h16M8 16h16M8 22h10"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <div className="text-sm font-semibold leading-tight">
            CeroDeuda
            <div className="text-xs font-normal text-slate-500">Lead Sync</div>
          </div>
        </div>

        <nav className="flex-1 space-y-4 px-3">
          {sections.map((section) => (
            <div key={section.title} className="space-y-1">
              <div className="px-3 pt-2 text-xs font-semibold uppercase tracking-wide text-slate-400">
                {section.title}
              </div>
              {section.items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    clsx(
                      "block rounded-md px-3 py-2 text-sm font-medium",
                      isActive
                        ? "bg-brand-50 text-brand-700"
                        : "text-slate-700 hover:bg-slate-100",
                    )
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>

        <div className="border-t border-slate-200 p-3">
          <button
            type="button"
            onClick={logout}
            className="btn-secondary w-full"
          >
            Log out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-auto">
        <div className="mx-auto max-w-7xl px-6 py-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
